var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myOrder" },
    [
      _c(
        "div",
        { staticClass: "top" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", { attrs: { label: "全部", name: "first" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "sub-main"
                  },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.columns,
                        "data-source": _vm.receiveList,
                        bordered: "",
                        pagination: false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "state",
                          fn: function(val) {
                            return [
                              val == 0
                                ? _c("a", [_vm._v("待收货")])
                                : val == 1
                                ? _c("a", [_vm._v("待审核")])
                                : val == 2
                                ? _c("a", [_vm._v("待补款")])
                                : val == 3
                                ? _c("a", [_vm._v("已完成")])
                                : val == 4
                                ? _c("a", [_vm._v("被驳回")])
                                : _c("a", [_vm._v(_vm._s(val))])
                            ]
                          }
                        },
                        {
                          key: "operation",
                          fn: function(val, record) {
                            return [
                              record.state == 0
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 4
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("重新确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 1
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 2
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去补款")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 3
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "paginationBox" },
                      [
                        _vm.total > 10
                          ? _c("a-pagination", {
                              attrs: { total: _vm.total },
                              on: { change: _vm.onChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { name: "second" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        staticClass: "item specialBadge",
                        attrs: {
                          value: _vm.checkStateCounts["0"],
                          hidden: !_vm.checkStateCounts["0"]
                        }
                      },
                      [_vm._v("\n            待收货\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "sub-main"
                  },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.columns,
                        "data-source": _vm.receiveList,
                        bordered: "",
                        pagination: false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "state",
                          fn: function(val) {
                            return [
                              val == 0
                                ? _c("a", [_vm._v("待收货")])
                                : val == 1
                                ? _c("a", [_vm._v("待审核")])
                                : val == 2
                                ? _c("a", [_vm._v("待补款")])
                                : val == 3
                                ? _c("a", [_vm._v("已完成")])
                                : val == 4
                                ? _c("a", [_vm._v("被驳回")])
                                : _c("a", [_vm._v(_vm._s(val))])
                            ]
                          }
                        },
                        {
                          key: "operation",
                          fn: function(val, record) {
                            return [
                              record.state == 0
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 4
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("重新确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 1
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 2
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去补款")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 3
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "paginationBox" },
                      [
                        _vm.total > 10
                          ? _c("a-pagination", {
                              attrs: { total: _vm.total },
                              on: { change: _vm.onChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { name: "third" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        staticClass: "item specialBadge",
                        attrs: {
                          value: _vm.checkStateCounts["1"],
                          hidden: !_vm.checkStateCounts["1"]
                        }
                      },
                      [_vm._v("\n            待商家确认\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "sub-main"
                  },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.columns,
                        "data-source": _vm.receiveList,
                        bordered: "",
                        pagination: false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "state",
                          fn: function(val) {
                            return [
                              val == 0
                                ? _c("a", [_vm._v("待收货")])
                                : val == 1
                                ? _c("a", [_vm._v("待审核")])
                                : val == 2
                                ? _c("a", [_vm._v("待补款")])
                                : val == 3
                                ? _c("a", [_vm._v("已完成")])
                                : val == 4
                                ? _c("a", [_vm._v("被驳回")])
                                : _c("a", [_vm._v(_vm._s(val))])
                            ]
                          }
                        },
                        {
                          key: "operation",
                          fn: function(val, record) {
                            return [
                              record.state == 0
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 4
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("重新确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 1
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 2
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去补款")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 3
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "paginationBox" },
                      [
                        _vm.total > 10
                          ? _c("a-pagination", {
                              attrs: { total: _vm.total },
                              on: { change: _vm.onChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { name: "four" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        staticClass: "item specialBadge",
                        attrs: {
                          value: _vm.checkStateCounts["2"],
                          hidden: !_vm.checkStateCounts["2"]
                        }
                      },
                      [_vm._v("\n            待付款\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "sub-main"
                  },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.columns,
                        "data-source": _vm.receiveList,
                        bordered: "",
                        pagination: false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "state",
                          fn: function(val) {
                            return [
                              val == 0
                                ? _c("a", [_vm._v("待收货")])
                                : val == 1
                                ? _c("a", [_vm._v("待审核")])
                                : val == 2
                                ? _c("a", [_vm._v("待补款")])
                                : val == 3
                                ? _c("a", [_vm._v("已完成")])
                                : val == 4
                                ? _c("a", [_vm._v("被驳回")])
                                : _c("a", [_vm._v(_vm._s(val))])
                            ]
                          }
                        },
                        {
                          key: "operation",
                          fn: function(val, record) {
                            return [
                              record.state == 0
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 4
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("重新确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 1
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 2
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去补款")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 3
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "paginationBox" },
                      [
                        _vm.total > 10
                          ? _c("a-pagination", {
                              attrs: { total: _vm.total },
                              on: { change: _vm.onChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { name: "five" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        staticClass: "item specialBadge",
                        attrs: {
                          value: _vm.checkStateCounts["3"],
                          hidden: !_vm.checkStateCounts["3"]
                        }
                      },
                      [_vm._v("\n            已完成\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "sub-main"
                  },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.columns,
                        "data-source": _vm.receiveList,
                        bordered: "",
                        pagination: false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "state",
                          fn: function(val) {
                            return [
                              val == 0
                                ? _c("a", [_vm._v("待收货")])
                                : val == 1
                                ? _c("a", [_vm._v("待审核")])
                                : val == 2
                                ? _c("a", [_vm._v("待补款")])
                                : val == 3
                                ? _c("a", [_vm._v("已完成")])
                                : val == 4
                                ? _c("a", [_vm._v("被驳回")])
                                : _c("a", [_vm._v(_vm._s(val))])
                            ]
                          }
                        },
                        {
                          key: "operation",
                          fn: function(val, record) {
                            return [
                              record.state == 0
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 4
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("重新确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 1
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 2
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去补款")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 3
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "paginationBox" },
                      [
                        _vm.total > 10
                          ? _c("a-pagination", {
                              attrs: { total: _vm.total },
                              on: { change: _vm.onChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { name: "six" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        staticClass: "item specialBadge",
                        attrs: {
                          value: _vm.checkStateCounts["4"],
                          hidden: !_vm.checkStateCounts["4"]
                        }
                      },
                      [_vm._v("\n            被驳回\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "sub-main"
                  },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.columns,
                        "data-source": _vm.receiveList,
                        bordered: "",
                        pagination: false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "state",
                          fn: function(val) {
                            return [
                              val == 0
                                ? _c("a", [_vm._v("待收货")])
                                : val == 1
                                ? _c("a", [_vm._v("待审核")])
                                : val == 2
                                ? _c("a", [_vm._v("待补款")])
                                : val == 3
                                ? _c("a", [_vm._v("已完成")])
                                : val == 4
                                ? _c("a", [_vm._v("被驳回")])
                                : _c("a", [_vm._v(_vm._s(val))])
                            ]
                          }
                        },
                        {
                          key: "operation",
                          fn: function(val, record) {
                            return [
                              record.state == 0
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 4
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("重新确认")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 1
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 2
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("去补款")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              record.state == 3
                                ? _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showDialog(record)
                                        }
                                      }
                                    },
                                    [_vm._v("查看详情")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "paginationBox" },
                      [
                        _vm.total > 10
                          ? _c("a-pagination", {
                              attrs: { total: _vm.total },
                              on: { change: _vm.onChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: { placeholder: "下单企业名称" },
                  model: {
                    value: _vm.formInline.recName,
                    callback: function($$v) {
                      _vm.$set(_vm.formInline, "recName", $$v)
                    },
                    expression: "formInline.recName"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: {
                      click: function($event) {
                        _vm.formInline.page = 1
                        _vm.getReceiveList()
                      }
                    },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "收货单",
            width: 1100,
            okText: _vm.curRow.state == 2 ? "补款" : "确定",
            "ok-button-props": {
              props: {
                disabled: _vm.curRow.state == 2 && _vm.curRow.checkerType == 1
              }
            }
          },
          on: { ok: _vm.handleOk },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "a-row",
            [
              _c("a-col", { attrs: { span: 6 } }, [
                _c("span", { staticClass: "miniLabel" }, [_vm._v("收货单位:")]),
                _vm._v(" "),
                _c("span", { staticClass: "miniText" }, [
                  _vm._v(_vm._s(_vm.curRow.recName))
                ])
              ]),
              _vm._v(" "),
              _c("a-col", { attrs: { span: 6 } }, [
                _c("span", { staticClass: "miniLabel" }, [_vm._v("订单编号:")]),
                _vm._v(" "),
                _c("span", { staticClass: "miniText" }, [
                  _vm._v(_vm._s(_vm.curRow.orderFormid))
                ])
              ]),
              _vm._v(" "),
              _c("a-col", { attrs: { span: 12 } }, [
                _c("span", { staticClass: "miniLabel" }, [_vm._v("收货地址:")]),
                _vm._v(" "),
                _c("span", { staticClass: "miniText" }, [
                  _vm._v(
                    _vm._s(_vm.curRow.recAddr + " " + _vm.curRow.supplierAddr)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("a-col", { attrs: { span: 6 } }, [
                _c("span", { staticClass: "miniLabel" }, [_vm._v("联系人:")]),
                _vm._v(" "),
                _c("span", { staticClass: "miniText" }, [
                  _vm._v(_vm._s(_vm.curRow.recContact))
                ])
              ]),
              _vm._v(" "),
              _c("a-col", { attrs: { span: 6 } }, [
                _c("span", { staticClass: "miniLabel" }, [_vm._v("联系电话:")]),
                _vm._v(" "),
                _c("span", { staticClass: "miniText" }, [
                  _vm._v(_vm._s(_vm.curRow.recPhone))
                ])
              ]),
              _vm._v(" "),
              _c("a-col", { attrs: { span: 12 } }, [
                _c("span", { staticClass: "miniLabel" }, [_vm._v("下单时间:")]),
                _vm._v(" "),
                _c("span", { staticClass: "miniText" }, [
                  _vm._v(_vm._s(_vm.curRow.orderCreateTime))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("a-table", {
            attrs: {
              columns:
                _vm.curRow.checkerType == 0
                  ? _vm.dialogColumns
                  : _vm.dialogColumns_copy,
              "data-source": _vm.curRow.details,
              bordered: "",
              pagination: false
            },
            scopedSlots: _vm._u([
              {
                key: "checkNumber",
                fn: function(val, row) {
                  return [
                    row.useDecimal
                      ? _c(
                          "div",
                          [
                            _vm.curRow.state == 0 || _vm.curRow.state == 4
                              ? _c("el-input-number", {
                                  attrs: {
                                    value: val,
                                    min: 0,
                                    precision: 2,
                                    step: 0.01
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleChange($event, row)
                                    }
                                  }
                                })
                              : _c("span", [_vm._v(_vm._s(val))])
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _vm.curRow.state == 0 || _vm.curRow.state == 4
                              ? _c("el-input-number", {
                                  attrs: { value: val, min: 0 },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleChange($event, row)
                                    }
                                  }
                                })
                              : _c("span", [_vm._v(_vm._s(val))])
                          ],
                          1
                        )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.curRow.checkerType == 0
            ? _c(
                "div",
                { staticClass: "moneyInfo" },
                [
                  _c("span", [_vm._v("应付金额总计")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        (
                          _vm.curRow.supplyAmount + Number(_vm.curRowFinalPrice)
                        ).toFixed(2)
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("首次已付金额")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.curRow.supplyAmount))]),
                  _vm._v(" "),
                  Number(_vm.curRowFinalPrice) != 0
                    ? [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              Number(_vm.curRowFinalPrice) >= 0
                                ? _vm.curRow.state == 3
                                  ? "已补款金额"
                                  : "需补款金额"
                                : _vm.curRow.state == 3
                                ? "已退款金额"
                                : "需退款金额"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              Math.abs(Number(_vm.curRowFinalPrice)).toFixed(2)
                            )
                          )
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.curRow.state == 1 || _vm.curRow.state == 3
            ? _c("div", { staticClass: "peopleInfo" }, [
                _c("span", [_vm._v("签收人")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.curRow.checkerName || "暂无"))]),
                _vm._v(" "),
                _c("span", [_vm._v("签收日期")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.curRow.checkTime || "暂无"))])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1baeadec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1baeadec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/receipt/receipt.vue
// module id = null
// module chunks = 